import React, { useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  Grid,
  Box,
  Typography,
  Stack,
  CircularProgress,
  Container,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import PremiumChoiceGroup from "../../../../Components/Inputs/PremiumChoiceGroup";
import PremiumInput from "../../../../Components/Inputs/PremiumInput";
export default function Question({ index , q, formik }) {
  const fieldName = q.question;
  const placeholder = q.placeholder || "";
  const isRequired = q.is_required !== undefined ? q.is_required : true;

  if (q.answer_type === "text") {
    return (
      <Grid size={{ xs: 12 }}>
        <PremiumInput
          name={`${index}`}
          label={q.question}
          formik={formik}
          multiline
          placeholder={placeholder}
        />
      </Grid>
    );
  }

  if (q.answer_type === "number") {
    return (
      <Grid size={{ xs: 12 }}>
        <PremiumInput
          name={`${index}`}
          label={q.question}
          formik={formik}
          type="number"
          placeholder={placeholder}
        />
      </Grid>
    );
  }

  if (q.answer_type === "boolean") {
    return (
      <Grid size={{ xs: 12 }}>
        <PremiumChoiceGroup
          name={`${index}`}
          label={q.question}
          formik={formik}
          options={[
            { value: "true", label: "بله" },
            { value: "false", label: "خیر" },
          ]}
          placeholder={placeholder}
        />
      </Grid>
    );
  }

  if (q.answer_type === "single_choice") {
    return (
      <Grid size={{ xs: 12 }}>
        <PremiumChoiceGroup
          name={`${index}`}
          label={q.question}
          formik={formik}
          options={q.answers?.map((ans) => ({ value: ans, label: ans })) || []}
          placeholder={placeholder}
        />
      </Grid>
    );
  }

  if (q.answer_type === "multiple_choice") {
    return (
      <Grid size={{ xs: 12 }}>
        <PremiumChoiceGroup
          name={`${index}`}
          label={q.question}
          formik={formik}
          multiple={true}
          options={q.answers?.map((ans) => ({ value: ans, label: ans })) || []}
          placeholder={placeholder}
        />
      </Grid>
    );
  }

  return null;
}
